export default __webpack_public_path__ + "static/media/profile.8eef9fef.jpg";